/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_SendingInputs */

const ja_contact_sending = /** @type {(inputs: Contact_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`送信中...`)
};

const en_contact_sending = /** @type {(inputs: Contact_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sending your Email!`)
};

/**
* | output |
* | --- |
* | "Sending your Email!" |
*
* @param {Contact_SendingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const contact_sending = /** @type {((inputs?: Contact_SendingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_SendingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_contact_sending(inputs)
	return en_contact_sending(inputs)
});